import { render } from "./ProjectsView.vue?vue&type=template&id=07c5ba18&scoped=true"
import script from "./ProjectsView.vue?vue&type=script&lang=js"
export * from "./ProjectsView.vue?vue&type=script&lang=js"

import "./ProjectsView.vue?vue&type=style&index=0&id=07c5ba18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c5ba18"]])

export default __exports__